'use strict';

var _ = require('lodash');
var ImportCsvStatusDirective = function ImportCsvStatusDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/import-csv-status.html'),
    controller: 'ImportCsvStatusController',
    scope: {
      statusId: '@',
      title: '@',
      statusMessage: '=',
      statusClass: '=',
      displayErrorsList: '=',
      errorReason: '=',
      errorMessages: '=',
      displayDownloadLink: '='
    }
  };
};
ImportCsvStatusDirective.$inject = [];
module.exports = ImportCsvStatusDirective;